// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"f38aad4c","281":"dfd8f6b9","326":"85b7f77f","333":"4a109378","347":"7a01806e"}[chunkId] + ".chunk.js";
};